import React from 'react'

import {
  BooleanInput
} from 'react-admin'

import Grid from '@material-ui/core/Grid'
import ApplicantFormInfo from './ApplicantFormInfo'
import ApplicantFormRasping from './ApplicantFormRasping'
import ApplicantAdditionallyRasping from './ApplicantAdditionallyRasping'

const ApplicantFormSteps = ({
  step,
  values: {
    checkOldRegNumber,
    foreignEducation
  },
  ...props
}) => {
  switch (step) {
    case 0:
      return <ApplicantFormInfo {...props} checkOldRegNumber={checkOldRegNumber} />
    case 1:
      return <ApplicantFormRasping {...props} foreignEducation={foreignEducation} />
    case 2:
      return (
        <>
          <ApplicantAdditionallyRasping />
          <Grid item xs={12}>
            <div style={{ marginTop: 10 }}>
              <BooleanInput label="Льготный пользователь" source="privilege" />
            </div>
            <div style={{ marginTop: 10 }}>
              <BooleanInput label="Я подтверждаю достоверность указанной при регистрации информации" source="conset" />
            </div>
            <div style={{ marginTop: 10 }}>
              <BooleanInput
                  label={(
                      <div>
                        Я даю согласие на обработку моих персональных данных, предоставленных при регистрации, в соответствии с
                        <br />
                        <a style={{ color: '#c62828' }} href="https://eak-rus.ru/files/Politika_obrabotkiki_personalnyh_dannyh_red_2_2025.pdf" target="_blank">
                          Политикой обработки персональных данных, размещенной на сайте АНО "ЕАК"
                        </a>
                      </div>
                  )}
                  source="personal"
              />
            </div>
            <div style={{ marginTop: 10 }}>
              <BooleanInput
                label={(
                  <div>
                    Я ознакомился с
                    {' '}
                    <a style={{ color: '#c62828' }} href="https://eak-rus.ru/files/2022/poryadok_provedeniya_kval_ekzamena_s_01_01_20231.pdf" target="_blank">Порядком проведения квалификационного экзамена</a>
                    {' '}
                    и подтверждаю свое согласие на участие в экзамене в соответствии с указанным Порядком
                  </div>
                )}
                source="accept"
              />
            </div>
          </Grid>
        </>
      )
    default:
      return null
  }
}

export default ApplicantFormSteps
